import React from "react"
import { VACATION_PERIOD_NAVIGATOR_MODES } from "../../consts/modules/vacations.consts"
import VacationsManagement from "./controllers/management/VacationsManagement.controller"
import MyVacations from "./controllers/myVacations/MyVacations.controller"
import { View404 } from "../systemPages/View404.view"
import VacationsReport from "./controllers/vacationsReport/VacationsReport.controller"
import VacationsHistory from "./controllers/vacationsHistory/VacationsHistory.controller"

/**
 * @param {VacationsViewProps} param0
 */
const Vacations = ({ mode = VACATION_PERIOD_NAVIGATOR_MODES.MANAGEMENT }) => {
  switch (mode) {
    case VACATION_PERIOD_NAVIGATOR_MODES.MANAGEMENT:
      return <VacationsManagement />
    case VACATION_PERIOD_NAVIGATOR_MODES.PERIOD:
      return <MyVacations />
    case VACATION_PERIOD_NAVIGATOR_MODES.REPORT:
      return <VacationsReport />
    case VACATION_PERIOD_NAVIGATOR_MODES.HISTORY:
      return <VacationsHistory isAdminView={true} />
    case VACATION_PERIOD_NAVIGATOR_MODES.HISTORY_TEAM_MEMBER:
      return <VacationsHistory isAdminView={false}/>
    default:
      return <View404 />
  }
}

export default Vacations

/**
 * @typedef {Object} VacationsViewProps
 * @property {typeof VACATION_PERIOD_NAVIGATOR_MODES[keyof typeof VACATION_PERIOD_NAVIGATOR_MODES]} mode - The current mode of the vacations view.
 */
